import { useCallback, useEffect } from "react";

export interface Shortcut {
  key: string;
  cb: () => void;
}
export function useShortcut(shortcuts: Shortcut[]) {
  const handleKeyDown = useCallback(
    (e: KeyboardEvent) => {
      shortcuts.forEach((shortcut) => {
        if (e.code === `Key${shortcut.key.toUpperCase()}` && e.altKey) {
          e.preventDefault();
          shortcut.cb();
        }
      });
    },
    [shortcuts]
  );
  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleKeyDown]);
}
